import * as classNames from "classnames"
import * as map from "lodash/map"
import { LinkTargetProperties } from "global/components/linkSettings/interfaces"
import { HyperLinkBuilder, SimpleLinkRenderer } from "../../../../../commonComponents/inline/hyperLink"

export interface HamburgerMenuItems {
    title: string
    link: string
    linkTarget: LinkTargetProperties
    color: string
    bgColor?: string
    isSelected?: boolean
    categoryId: string
    isBolded?: boolean
}


interface MenuProps {
    menuItems: HamburgerMenuItems[]
    width: number
    isOpenedHam: boolean
    menuGroup1: HamburgerMenuItems[]
    menuGroup2: HamburgerMenuItems[]
    menuGroup3: HamburgerMenuItems[]
    menuGroup4: HamburgerMenuItems[]
    menuGroup5: HamburgerMenuItems[]
}

export class MenuListComponenta extends React.Component<MenuProps, {}> {
    constructor(props) {
        super(props)
    }


    render() {
        const { menuItems, width, isOpenedHam, menuGroup1, menuGroup2, menuGroup3, menuGroup4, menuGroup5 } = this.props
        let style = { width: `${width}px` }
        const opened = isOpenedHam ? "opened" : "";
        
        return (
            <div className={`CalcalistMeniList ${opened}`} style={style} >
            <div className="menuGroupsContainer">
                <div className="menuColumn column1">
                    <h3>פורטל פיננסי</h3>
                    <ul>
                    {map(menuGroup1, (item, i) =>
                        <li key={i}>
                            <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} style={{ color: item.color, background: item.bgColor }}>
                                <span dangerouslySetInnerHTML={{ __html: item.title }} />
                            </HyperLinkBuilder>
                        </li>)}
                    </ul> 
                    <h3 className="group2">כלכליסט ברשת</h3>
                    <ul>
                        {map(menuGroup2, (item, i) =>
                            <li key={i}>
                                <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} style={{ color: item.color, background: item.bgColor }}>
                                    <span dangerouslySetInnerHTML={{ __html: item.title }} />
                                </HyperLinkBuilder>
                            </li>)}
                    </ul>
                </div>
                
                <div className="menuColumn column2">
                    <h3>ערוצי כלכליסט</h3>
                    <ul> 
                        {map(menuGroup3, (item, i) =>
                            <li key={i}>
                                <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} style={{ color: item.color, background: item.bgColor }}>
                                    <span dangerouslySetInnerHTML={{ __html: item.title }} />
                                </HyperLinkBuilder>
                            </li>)}
                    </ul>
                </div>

                <div className="menuColumn column3">
                    <h3>ערוצים נוספים</h3>
                    <ul>
                        {map(menuGroup4, (item, i) =>
                            <li key={i}>
                                <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} style={{ color: item.color, background: item.bgColor }}>
                                    <span dangerouslySetInnerHTML={{ __html: item.title }} />
                                </HyperLinkBuilder>
                            </li>)}
                    </ul> 
                </div>
               
               <div className="menuColumn column4">
                <h3>יצירת קשר</h3>
                <ul>
                    {map(menuGroup5, (item, i) =>
                        <li key={i}>
                            <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} style={{ color: item.color, background: item.bgColor }}>
                                <span dangerouslySetInnerHTML={{ __html: item.title }} />
                            </HyperLinkBuilder>
                        </li>)}
                </ul>  
                </div> 
                       
            </div>
            </div>
        )
    } 
}